import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiModerateWorldVariables = Types.Exact<{
  id: Types.Scalars['Int'];
  moderationStatus: Types.ApiModerationStatus;
  moderationFrom?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ApiModerateWorld = { updateExhibition: { name: string, moderationStatus: Types.ApiModerationStatus } | null };



export const ApiModerateWorldDocument = /*#__PURE__*/ `
    mutation ModerateWorld($id: Int!, $moderationStatus: ModerationStatus!, $moderationFrom: String) {
  updateExhibition(
    exhibitionId: $id
    moderationStatus: $moderationStatus
    moderationFrom: $moderationFrom
  ) {
    name
    moderationStatus
  }
}
    `;

export const useModerateWorld = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiModerateWorld, TError, ApiModerateWorldVariables, TContext>) => {
    
    return useMutation<ApiModerateWorld, TError, ApiModerateWorldVariables, TContext>(
      {
    mutationKey: ['ModerateWorld'],
    mutationFn: (variables?: ApiModerateWorldVariables) => apiFetcher<ApiModerateWorld, ApiModerateWorldVariables>(ApiModerateWorldDocument, variables)(),
    ...options
  }
    )};


useModerateWorld.fetcher = (variables: ApiModerateWorldVariables, options?: RequestInit['headers']) => apiFetcher<ApiModerateWorld, ApiModerateWorldVariables>(ApiModerateWorldDocument, variables, options);
